import React from 'react';
import { DollarSign, Clock, ShieldCheck, FileText, Headphones, TrendingUp } from 'lucide-react';

const REASONS = [
  { icon: DollarSign, title: 'More Money Per Mile', desc: 'We negotiate every load with live market data so your rate stays well above average.' },
  { icon: Clock, title: '24/7 Dispatch', desc: 'Real people answer the phone day or night to keep your wheels turning.' },
  { icon: ShieldCheck, title: 'Broker Credit Checks', desc: 'Every broker is vetted before booking so you always get paid for your miles.' },
  { icon: FileText, title: 'Paperwork Handled', desc: 'Rate cons, packets, lumpers, and detention claims managed end to end.' },
  { icon: TrendingUp, title: 'Less Deadhead', desc: 'Smart backhaul planning keeps your trailer loaded in both directions.' },
  { icon: Headphones, title: 'No Long Contracts', desc: 'Simple flat dispatch fees and the freedom to leave anytime. We earn your loyalty.' },
];

export const WhyChooseUs = () => (
  <section className="py-20 bg-gray-50" data-testid="why-choose-us">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Flow Fleet Solutions</h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          We are more than a dispatcher. We are your partner in profitability, handling the hard stuff so you can drive and get paid.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REASONS.map((r, i) => (
          <div key={i} className="bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-orange-200 hover:shadow-xl transition-all duration-300" data-testid={`reason-${i}`}>
            <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-5">
              <r.icon className="h-7 w-7 text-orange-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">{r.title}</h3>
            <p className="text-gray-600 leading-relaxed">{r.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
